<template>
  <div class="min-h-screen bg-slate-50">
    
    <div class="max-w-2xl mx-auto px-4 py-8">
      <div class="bg-white border border-slate-200 rounded-2xl shadow-sm overflow-hidden">
        <div class="h-1 bg-[#FFF200]"></div>

        <div class="p-6 space-y-5">
          <h1 class="text-xl font-semibold">ยืนยันตัวตนเพื่อสมัครเข้าร่วมโครงการ ODOS Summer Camp (Class of 2026)</h1>
          <div>
              <label class="label">IDCARD *</label>
              <input class="brand-input" v-model="form.idcard" placeholder="idcard" readonly/>
          </div>
          <div>
            <label class="label">ชื่อ (First name) *</label>
            <input class="brand-input" v-model="form.firstName" placeholder="ชื่อ" readonly/>
          </div>
          <div>
            <label class="label">นามสกุล (Last name) *</label>
            <input class="brand-input" v-model="form.lastName" placeholder="นามสกุล" readonly />
          </div>

          <div>
            <label class="label">อีเมล *</label>
            <input class="brand-input" v-model="form.email" placeholder="you@example.com" readonly />
          </div>

          <div>
            <label class="label">เบอร์โทร *</label>
            <input class="brand-input" v-model="form.mobile" placeholder="0800000000" readonly />
          </div>

          <div>
            <label class="label">วันเดือนปีเกิด *</label>
            <input class="brand-input" type="text" v-model="form.birthDate" placeholder="YYYY-MM-DD" readonly />
          </div>

          <div class="flex items-center gap-3 pt-2">
            <button class="btn-brand" :disabled="submitting" @click="onSubmit">
              {{ submitting ? 'กำลังส่ง...' : 'ส่งแบบฟอร์ม' }}
            </button>
            <span v-if="error" class="text-sm text-red-600">{{ error }}</span>
            <!-- <span v-if="successMsg" class="text-sm text-emerald-700">{{ successMsg }}</span> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted  } from 'vue'
import { useRoute } from 'vue-router'
import { useRouter } from 'vue-router'
import api from '../api/http'
import Swal from 'sweetalert2'

const route = useRoute()
const router = useRouter()

const form = ref({
  idcard: '',
  firstName: '',
  lastName: '',
  email: '',
  phone:'',
  birthDate: '' 
})

onMounted(() => {  
  if (route.query.citizenId) {
    form.value.idcard = route.query.citizenId
  }
  if (route.query.firstName) {
    form.value.firstName = route.query.firstName
  }
  if (route.query.lastName) {
    form.value.lastName = route.query.lastName
  }
  if (route.query.email) {
    form.value.email = route.query.email
  }
  if (route.query.mobile) {
    form.value.mobile = route.query.mobile
  }
  if (route.query.birthDate) {
    form.value.birthDate = formatBirthDate(route.query.birthDate)
  }
})

const submitting = ref(false)
const error = ref('')
const successMsg = ref('')

function formatBirthDate(val) {
  
  if (!val || val.length !== 8) return ''
  const y = val.slice(0, 4)
  const m = val.slice(4, 6)
  const d = val.slice(6, 8)
  return `${y}-${m}-${d}`
}


function validate() {
  error.value = ''
  if (!form.value.firstName.trim()) { error.value = 'กรุณากรอกชื่อ'; return false }
  if (!form.value.lastName.trim()) { error.value = 'กรุณากรอกนามสกุล'; return false }
  if (!form.value.email.trim())      { error.value = 'กรุณากรอกอีเมล'; return false }
  if (!/\S+@\S+\.\S+/.test(form.value.email)) { error.value = 'รูปแบบอีเมลไม่ถูกต้อง'; return false }
  if (!form.value.birthDate) { error.value = 'กรุณาเลือกวันเดือนปีเกิด'; return false }
  if (!form.value.mobile.trim()) {error.value = 'กรุณากรอกเบอร์โทร'; return false}

  return true
}

async function onSubmit() {
  if (!validate()) return

  Swal.fire({
    title: 'กำลังส่งข้อมูล...',
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading()
    }
  })


  submitting.value = true
  successMsg.value = ''
  try {
    
    const fd = new FormData()
    fd.append('idcard', form.value.idcard)
    fd.append('firstName', form.value.firstName)
    fd.append('lastName', form.value.lastName)
    fd.append('email', form.value.email)
    fd.append('mobile', form.value.mobile)    
    fd.append('birthDate', form.value.birthDate)

    const { data } = await api.post('/forms', fd, { headers: { 'Content-Type': 'multipart/form-data' } })

    Swal.close()

    if (data) {      
      Swal.fire({
        icon: 'success',
        title: 'ส่งข้อมูลเรียบร้อย!',
        confirmButtonText: 'ตกลง'
      }).then(() => {
        router.push({
          path: '/success',
          query: {
            email: form.value.email
          }
        })
      })
    }
    // form.value = { firstName: '', lastName: '', email: '', birthDate: '' }
  } catch (e) {
    Swal.close()
    error.value = 'ส่งแบบฟอร์มไม่สำเร็จ เนื่องจากมีผู้ใช้งานระบบเป็นจำนวนมาก โปรดลองอีกครั้งในภายหลัง'
    Swal.fire({
      icon: 'error',
      title: 'เกิดข้อผิดพลาด',
      text: error.value
    })
  } finally {
    submitting.value = false
  }
}
</script>


<style scoped>
input[readonly] {
  background-color: #e5e7eb; 
  color: #374151;             
  cursor: not-allowed;        
}
  .label{ 
    @apply block text-sm font-medium text-slate-700 mb-1; 
  }
  .brand-input{
    @apply w-full rounded-xl border px-3 py-2 bg-white;
    @apply border-slate-300 focus:outline-none focus:ring-2;
    /* ใช้ arbitrary color ของ Tailwind */
    --tw-ring-color: #FFF200;
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    border-color: #e5e7eb;
  bg-color: #FFF200;
}
.btn-brand{
  @apply inline-flex items-center justify-center rounded-xl px-4 py-2 font-medium text-slate-900 shadow-sm;
  background: #FFF200;
}
.btn-brand:disabled{ 
  @apply opacity-60 cursor-not-allowed; 
}     
</style>
